/* tslint:disable */
/* eslint-disable */
export enum TypeAttributes {
  NotPublic = 'NotPublic',
  Public = 'Public',
  NestedPublic = 'NestedPublic',
  NestedPrivate = 'NestedPrivate',
  NestedFamily = 'NestedFamily',
  NestedAssembly = 'NestedAssembly',
  NestedFamAndAssem = 'NestedFamANDAssem',
  VisibilityMask = 'VisibilityMask',
  SequentialLayout = 'SequentialLayout',
  ExplicitLayout = 'ExplicitLayout',
  LayoutMask = 'LayoutMask',
  Interface = 'Interface',
  Abstract = 'Abstract',
  Sealed = 'Sealed',
  SpecialName = 'SpecialName',
  RtSpecialName = 'RTSpecialName',
  Import = 'Import',
  Serializable = 'Serializable',
  WindowsRuntime = 'WindowsRuntime',
  UnicodeClass = 'UnicodeClass',
  AutoClass = 'AutoClass',
  StringFormatMask = 'StringFormatMask',
  HasSecurity = 'HasSecurity',
  ReservedMask = 'ReservedMask',
  BeforeFieldInit = 'BeforeFieldInit',
  CustomFormatMask = 'CustomFormatMask'
}
